

export const SET_PRIMARY_COLOR = "SET_PRIMARY_COLOR"
export const SET_SECONDARY_COLOR = "SET_SECONDARY_COLOR"
export const SET_TEXT_SECONDARY_COLOR = "SET_TEXT_SECONDARY_COLOR"
export const SET_FONT = "SET_FONT"
export const SET_LOGO = "SET_LOGO"
export const SET_LANGUAGE = "SET_LANGUAGE"
export const SET_INITIAL_THEME = "SET_INITIAL_THEME"
export const SET_VENDOR_NAME = "SET_VENDOR_NAME"
export const RESET_THEME = "RESET_THEME"
export const SET_PRODUCTS_ORDER = "SET_PRODUCTS_ORDER"
export const SET_ORDER_BUTTON_LABEL = "SET_ORDER_BUTTON_LABEL"
export const SET_ORDER_BUTTON_ACTION = "SET_ORDER_BUTTON_ACTION"
export const SET_ANALYTICS_ENABLED = "SET_ANALYTICS_ENABLED"
export const SET_UNIT_DISPLAY = "SET_UNIT_DISPLAY"
export const SET_CORNER_RADIUS = "SET_CORNER_RADIUS"
export const SET_VISUALIZER_FILTERS = "SET_VISUALIZER_FILTERS"
export const SET_PRODUCT_CARD_FIELDS = "SET_PRODUCT_CARD_FIELDS"